import React from 'react';
import { MapPin, Clock, Instagram, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="section-padding bg-gradient-to-b from-black via-[#0a0a0a] to-black relative overflow-hidden">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#c9a961]/5 rounded-full blur-[120px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#c9a961] text-sm font-semibold tracking-[0.2em] uppercase">Get in Touch</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl md:text-6xl font-light text-[#f8f6f0] mb-6">
            Visit Us in
            <span className="block text-[#c9a961]">Downtown Vancouver</span>
          </h2>
          <p className="text-[#f8f6f0]/70 text-lg max-w-2xl mx-auto">
            Ready to transform your hair? Book your appointment online.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/30 p-10">
              <h3 className="font-['Playfair_Display'] text-4xl text-[#f8f6f0] mb-8">Prép Beauty Parlour</h3>
              
              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#c9a961]/10 flex items-center justify-center">
                    <MapPin className="text-[#c9a961]" size={22} />
                  </div>
                  <div>
                    <div className="text-[#f8f6f0] font-medium mb-2 text-lg">Location</div>
                    <div className="text-[#f8f6f0]/70 leading-relaxed">1305 Burrard St</div>
                    <div className="text-[#f8f6f0]/70 leading-relaxed">Vancouver, BC V6Z 1Z7</div>
                    <div className="text-[#c9a961] text-sm mt-2">West End | Yaletown | Davie Village</div>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#c9a961]/10 flex items-center justify-center">
                    <Phone className="text-[#c9a961]" size={22} />
                  </div>
                  <div>
                    <div className="text-[#f8f6f0] font-medium mb-2 text-lg">Phone</div>
                    <a
                      data-testid="contact-phone"
                      href="tel:+16047646452"
                      className="text-[#c9a961] hover:text-[#d4af37] transition-colors text-lg"
                    >
                      (604) 764-6452
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#c9a961]/10 flex items-center justify-center">
                    <Clock className="text-[#c9a961]" size={22} />
                  </div>
                  <div>
                    <div className="text-[#f8f6f0] font-medium mb-2 text-lg">Hours</div>
                    <div className="text-[#f8f6f0]/70 text-sm space-y-1">
                      <div>Monday - Friday: 10:00 AM - 7:00 PM</div>
                      <div>Saturday: 10:00 AM - 6:00 PM</div>
                      <div>Sunday: 11:00 AM - 6:00 PM</div>
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#c9a961]/10 flex items-center justify-center">
                    <Instagram className="text-[#c9a961]" size={22} />
                  </div>
                  <div>
                    <div className="text-[#f8f6f0] font-medium mb-2 text-lg">Follow Us</div>
                    <div className="space-y-1">
                      <a
                        data-testid="contact-instagram"
                        href="https://www.instagram.com/prepbeautyparlour"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block text-[#c9a961] hover:text-[#d4af37] transition-colors text-lg"
                      >
                        @prepbeautyparlour (Instagram)
                      </a>
                      <a
                        data-testid="contact-tiktok"
                        href="https://www.tiktok.com/@prepbeautyparlour"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block text-[#c9a961] hover:text-[#d4af37] transition-colors text-lg"
                      >
                        @prepbeautyparlour (TikTok)
                      </a>
                      <a
                        data-testid="contact-classpass"
                        href="https://classpass.com/studios/prp-beauty-parlour-vancouver"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block text-[#c9a961] hover:text-[#d4af37] transition-colors text-lg"
                      >
                        Book on ClassPass
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-[#c9a961]/20">
                <Button
                  data-testid="contact-book-cta"
                  onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
                  className="w-full bg-gradient-to-r from-[#c9a961] to-[#8b6f3e] hover:from-[#d4af37] hover:to-[#c9a961] text-black font-semibold py-6 text-lg rounded-none transition-all duration-300 hover:shadow-[0_0_40px_rgba(201,169,97,0.5)]"
                >
                  Book Online Now
                </Button>
              </div>
            </div>
          </div>

          {/* Map placeholder */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/30 flex items-center justify-center p-10">
            <div className="text-center">
              <MapPin className="text-[#c9a961] mx-auto mb-6" size={48} />
              <h4 className="font-['Playfair_Display'] text-2xl text-[#f8f6f0] mb-4">Find Us</h4>
              <p className="text-[#f8f6f0]/70 mb-6">1305 Burrard St, Vancouver</p>
              <a
                data-testid="contact-map-link"
                href="https://www.google.com/maps/search/?api=1&query=1305+Burrard+St+Vancouver"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-[#c9a961] hover:text-[#d4af37] font-medium transition-colors border-b border-[#c9a961]/30 hover:border-[#c9a961] pb-1"
              >
                View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
